// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__39mKp","colBig":"styles_colBig__A9yDG","colSmall":"styles_colSmall__2RiC1","shopifyNameWrapper":"styles_shopifyNameWrapper___6QUe"};